module.exports = __webpack_public_path__ + "static/media/start-1.043d8d4f.jpg";